import React from 'react';

/**
 * Shimmer Card Component
 * Provides loading state animation for summary cards
 */
const ShimmerCard = ({ className = "" }) => {
  return (
    <div className={`bg-white dark:bg-gray-900 rounded-2xl p-6 border border-gray-200 dark:border-gray-700 shadow-sm dark:shadow-gray-900/20 transition-colors duration-300 ${className}`}>
      <div className="flex items-center justify-between">
        <div className="flex-1">
          {/* Label shimmer */}
          <div className="shimmer-text w-20 mb-3"></div>
          
          {/* Value shimmer */}
          <div className="shimmer-number-lg mb-2"></div>
          
          {/* Subtext shimmer */}
          <div className="shimmer-text w-16"></div>
        </div>
        
        {/* Icon shimmer */}
        <div className="w-12 h-12 bg-gray-200 dark:bg-gray-700 rounded-lg shimmer"></div>
      </div>
    </div>
  );
};

/**
 * Animated Summary Card Component
 * Shows actual content or shimmer based on loading state
 */
export const SummaryCard = ({ 
  isLoading = false, 
  label, 
  value, 
  subtext, 
  icon, 
  iconBgColor = "bg-primary-100", 
  iconColor = "text-primary-600",
  valueColor = "text-gray-900 dark:text-gray-100",
  className = "" 
}) => {
  if (isLoading) {
    return <ShimmerCard className={className} />;
  }

  return (
    <div className={`bg-white dark:bg-gray-900 rounded-2xl p-6 border border-gray-200 dark:border-gray-700 shadow-sm dark:shadow-gray-900/20 hover:scale-[1.02] hover:shadow-md dark:hover:shadow-gray-900/40 transition-all duration-300 ${className}`}>
      <div className="flex items-center justify-between">
        <div className="flex-1">
          <p className="text-sm font-medium text-gray-600 dark:text-gray-400 mb-1 transition-opacity duration-500">
            {label}
          </p>
          <p className={`text-2xl font-bold mb-1 transition-opacity duration-500 ${valueColor}`}>
            {value}
          </p>
          {subtext && (
            <p className="text-sm text-gray-500 dark:text-gray-400 transition-opacity duration-500">
              {subtext}
            </p>
          )}
        </div>
        
        {icon && (
          <div className={`w-12 h-12 ${iconBgColor} dark:${iconBgColor.replace('100', '900/30')} rounded-lg flex items-center justify-center transition-opacity duration-500`}>
            <div className={`w-6 h-6 ${iconColor} dark:${iconColor.replace('600', '400')}`}>
              {icon}
            </div>
          </div>
        )}
      </div>
    </div>
  );
};

export default ShimmerCard;

